import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { GameHUD } from "./GameHUD";
import { PanelRightClose } from "lucide-react";

interface V2HUDPanelProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Spread onto <GameHUD>. Built by Play.tsx's useMemo. */
  hudProps: Record<string, any>;
}

/**
 * Slide-out panel wrapping the full GameHUD component.
 * Opens from the right on desktop/mobile (unified).
 */
export function V2HUDPanel({ open, onOpenChange, hudProps }: V2HUDPanelProps) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="right"
        className="w-full sm:max-w-md lg:max-w-lg p-0 flex flex-col"
      >
        <SheetHeader className="px-4 py-3 border-b border-border/60 shrink-0">
          <SheetTitle className="flex items-center gap-2 text-sm">
            <PanelRightClose className="w-4 h-4 text-primary" />
            Game HUD
          </SheetTitle>
        </SheetHeader>
        <div className="flex-1 overflow-hidden">
          <GameHUD {...(hudProps as any)} />
        </div>
      </SheetContent>
    </Sheet>
  );
}
